<template>
  <div
    class="m-font"
    :style="{
      width: width * scale + 'px',
      height: height * scale + 'px',
      backgroundPosition: '0px -' + (number - 1) * (height * scale) + 'px'
    }"
  ></div>
</template>
<script>
export default {
  props: {
    number: {
      type: Number,
      default: 1
    },
    scale: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      width: 29,
      height: 21
    }
  }
}
</script>
<style lang="scss" scoped>
.m-font {
  display: inline-block;
  width: 29px;
  height: 21px;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-number-font');
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: 0px 0px;
}
</style>
